import React from "react";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";
import { getLocationsForCustomer } from '../../../actions/location'

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import Radio from "material-ui/Radio";
import FormControlLabel from "material-ui/Form/FormControlLabel";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";

import Button from "components/CustomButtons/Button.jsx";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
};



class Step2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locations:[],
      location:null,
    };
    this.refreshLocations = this.refreshLocations.bind(this);

  }

  change = event => {
    this.setState({ [event.target.name]: event.target.value });
    this.props.change({ [event.target.name]: event.target.value });
  };
  
  isValidated() {
    return true;
  }

  refreshLocations(){
    this.props.dispatchGetLocations(this.props.auth.user)
    .then( locations => {
      this.setState({locations});
    });  
  }

  componentDidMount() {
    this.refreshLocations();
  }

  render() {
    const { classes } = this.props;

    return (
      <GridContainer justify="center">
        <ItemGrid xs={12} sm={12}>
          <h4 className={classes.infoText}>Are you living in a nice area?</h4>
        </ItemGrid>
        <ItemGrid xs={12} sm={12} md={8}>
          <Button onClick={this.refreshLocations}>Refresh locations</Button>
        </ItemGrid>

        <ItemGrid xs={12} sm={12} md={8}>
          {this.state.locations.map((prop,key)=>{
            return(
                  <FormControlLabel
                      key={key}                   
                      control={
                        <Radio
                          checked={this.state["location"] === prop.id.toString()}
                          onChange={this.change}
                          value={prop.id.toString()}
                          name="location"
                          aria-label={prop.nickname}
                        />
                      }
                      classes={{
                        label: classes.label
                      }}
                      label={prop.nickname+" (@"+prop.username+")"}
                    />
              )
          })}
        </ItemGrid>                  

      </GridContainer>
    );
  }
}

const mapDispatchToProps = {
  dispatchGetLocations: (user) => getLocationsForCustomer(user),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
  }
}


export default compose(
  withStyles(style),
  connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })
)(Step2);



// WEBPACK FOOTER //
// ./src/views/Customer/AddShipmentWizardSteps/Step2.jsx